import axios from "axios";
import graph from '../services/graph'

//poziv express-u da dohvati podatke vezane uz osobu
export default {
  getMembers(token, idGrupe) {
    try {
      return axios.get("https://app-psod.cratis.cloud/cases/sharepoint/" + idGrupe + "/member",
        {
          params: {
            token: token,
          }
        });
    } catch (err) {
      console.log(err);
    }
  },
  getOwners(token, idGrupe) {
    try {
      return axios.get("https://app-psod.cratis.cloud/cases/sharepoint/" + idGrupe + "/owner",
        {
          params: {
            token: token,
          }
        });
    } catch (err) {
      console.log(err);
    }
  },
  getSelf(accessToken) {
    try {
      return axios.get("https://app-psod.cratis.cloud/auth/user/current",
        {
          params: {
            token: accessToken,
          },
          credentials: true
        })

    }
    catch {
      console.log("Failed attempt at person.");
    }

  },
  getSelfAnalytics(accessToken) {
    try {
      return axios.get("https://app-psod.cratis.cloud/auth/user/current/start-analytics",
        {
          params: {
            token: accessToken,
          },
          credentials: true
        })

    }
    catch {
      console.log("Failed attempt at person.");
    }

  },
  getSearchEvents(uid, srch_txt) {
    try {
      return axios.get("https://app-psod.cratis.cloud/auth/user/current/events-search",
        {
          params: {
            uid,
            srch_txt
          },
          credentials: true
        })

    }
    catch {
      console.log("Failed attempt at person.");
    }

  },
  getFilteredUsers(accessToken, tekst) {
    try {
      return axios.get("https://app-psod.cratis.cloud/auth/users",
        {
          params: {
            token: accessToken,
            tekst: String(tekst)
          },
          credentials: true
        })

    }
    catch {
      console.log("Failed attempt at person.");
    }

  },
  getUserPhoto(uid) {
    try {
      return axios.post("https://app-psod.cratis.cloud/auth/user/current/avatar",

        {
          params: {
            uid
          },
          credentials: true,
          
        },{
          responseType : "blob"
        })

    }
    catch {
      console.log("Failed attempt at person.");
    }

  },
  addNewAvatar(formData) {
    try {
      return axios.post("https://app-psod.cratis.cloud/auth/user/current/avatar/new", formData)
    }
    catch {
      console.log("Failed attempt at person.");
    }

  },
  addNewMember(token, idGrupe, korisnik) {
    try {
      return axios.post("https://app-psod.cratis.cloud/cases/sharepoint/" + idGrupe + "/member",
        {
          params: {
            token: token,
            korisnik: korisnik
          }
        });
    } catch (err) {
      console.log(err);
    }
  },
  removeMember(token, idGrupe, korisnik) {
    try {
      return axios.delete("https://app-psod.cratis.cloud/cases/sharepoint/" + idGrupe + "/member",
        {
          params: {
            token: token,
            korisnik: korisnik
          }
        });
    } catch (err) {
      console.log(err);
    }
  },
  removeOwner(token, idGrupe, korisnik) {
    try {
      return axios.delete("https://app-psod.cratis.cloud/cases/sharepoint/" + idGrupe + "/owner",
        {
          params: {
            token: token,
            korisnik: korisnik
          }
        });
    } catch (err) {
      console.log(err);
    }
  },
  addNewOwner(token, idGrupe, korisnik) {
    try {
      return axios.post("https://app-psod.cratis.cloud/cases/sharepoint/" + idGrupe + "/owner",
        {
          params: {
            token: token,
            korisnik: korisnik
          }
        });
    } catch (err) {
      console.log(err);
    }
  },


}

